import { computed } from 'vue'
import { useStore } from 'vuex'

export function useMapGetters(moduleName: string, getterNames: string[]): Record<string, any> {
  const store = useStore()
  return getterNames.reduce((acc, getterName) => {
    acc[getterName] = computed(() => store.getters[`${moduleName}/${getterName}`])
    return acc
  }, {} as Record<string, any>)
}
